<template>
  <TableCartBase
    :items="items"
    container-classes="h-full flex flex-col bg-white shadow-xl"
    :show-pin-button="true"
    pin-button-type="unpin"
    :is-checkout-active="isCheckoutActive"
    :is-store-closed="isStoreClosed"
    @unpin="$emit('unpin')"
    @update-quantity="onUpdateQuantity"
    @remove-item="$emit('remove-item', $event)"
    @edit-item="$emit('edit-item', $event)"
    @checkout="$emit('checkout')"
    @view-check="$emit('view-check')"
  >
  </TableCartBase>
</template>

<script>
import TableCartBase from "./TableCartBase.vue";

export default {
  name: "TableCartSidebar",
  components: {
    TableCartBase
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isPinned: {
      type: Boolean,
      default: true
    },
    isCheckoutActive: {
      type: Boolean,
      default: false
    },
    isStoreClosed: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update-quantity",
    "remove-item",
    "edit-item",
    "checkout",
    "view-check",
    "unpin"
  ],
  methods: {
    onUpdateQuantity(cartId, delta) {
      this.$emit("update-quantity", cartId, delta);
    }
  }
};
</script>
